import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6f7eef42"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "cast-director-list",
  "element-loading-background": "transparent"
};
const _hoisted_2 = {
  class: "left-warp"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "right-warp"
};
import { getCastOrDirectorListApi } from '@/api/vodPlus';
import { inject, onMounted } from 'vue';
import CastOrDirectorDetail from './castOrDirectorDetail.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'castOrDirectorList',
  emits: ['onCardClick'],

  setup(__props, {
    emit
  }) {
    const searchParams = reactive({
      searchValue: '',
      loading: false,
      paginationConfig: {
        page: 1,
        limit: 12,
        total: 13
      }
    });
    const detailInfo = ref(null);
    const castOrDirectorList = ref([]);
    const showCastOrDirectorDetail = ref(false);
    const castOrDirectorDetailRef = ref(null);
    const datekey = ref(Date.now());

    const getData = async () => {
      console.log('get Data');
      searchParams.loading = true;

      try {
        const {
          imdbId,
          apiType
        } = currentParams.value;
        const res = await getCastOrDirectorListApi({
          imdbId,
          type: apiType
        });
        console.log(res);

        if (res.status == 200) {
          castOrDirectorList.value = res.data.castList;
          detailInfo.value = res.data.castList.length && res.data.castList[0];
          showCastOrDirectorDetail.value = true;
        }
      } catch (error) {
        console.log(error);
      }

      searchParams.loading = false;
    };

    const handlePaginationChange = val => {
      searchParams.paginationConfig.page = val;
      getData();
    };

    const currentLeftIndex = ref(0);

    const handleLeftItemClick = (item, index) => {
      console.log(item);
      if (currentLeftIndex.value == index) return;
      currentLeftIndex.value = index;
      detailInfo.value = item;
      showCastOrDirectorDetail.value = false;
      datekey.value = Date.now();
      showCastOrDirectorDetail.value = true;
    };

    const onCardClick = item => {
      emit('onCardClick', item);
    };

    onMounted(() => {
      // console.log(currentParams.value);
      getData();
    });
    const currentUiStyleOptions = inject('currentUiStyleOptions');
    const currentParams = inject('currentParams');
    return (_ctx, _cache) => {
      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [!searchParams.loading ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(castOrDirectorList.value, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["pointer", currentLeftIndex.value == index ? 'is-active' : '']),
          key: item,
          onClick: $event => handleLeftItemClick(item, index)
        }, _toDisplayString(item.name), 11, _hoisted_3);
      }), 128))])]), _createElementVNode("div", _hoisted_4, [showCastOrDirectorDetail.value ? (_openBlock(), _createBlock(CastOrDirectorDetail, {
        key: datekey.value,
        ref_key: "castOrDirectorDetailRef",
        ref: castOrDirectorDetailRef,
        "name-id": detailInfo.value.nameId,
        image: detailInfo.value.image,
        name: detailInfo.value.name,
        onOnCardClick: onCardClick
      }, null, 8, ["name-id", "image", "name"])) : _createCommentVNode("", true)])], 64)) : _createCommentVNode("", true)])), [[_directive_loading, searchParams.loading]]);
    };
  }

});